import CustomerContactModel from "@/models/crm/CustomerContactModel";
import CrmServiceCollection from "@/collections/CrmServiceCollection";

export default class CustomerContactCollection extends CrmServiceCollection {
  model() {
    return CustomerContactModel;
  }

}
